import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

const GRAPH_URL: string = '/rest/prl-graph/';

@Injectable({
    providedIn: 'root'
})
export class PrlDashboardGraphDataService  {

    constructor(private httpClient: HttpClient) {
    }

    public getGraphsList(language: any): Observable<any> {
        let url = GRAPH_URL + 'list';
        url = language ? url + '/language/' + language : url;
        return this.httpClient.get(url);
    }

    public getGraphData(graphInput: any) {
        const url = GRAPH_URL + 'data';
        return this.httpClient.post<void>(url, graphInput);
    }
}
